export default __webpack_public_path__ + "media/images/front/about/point_3-34c9eb7b072a75b489046f0b02da4a9f.png";